import { render } from "./Text.vue?vue&type=template&id=f741c252&scoped=true"
import script from "./Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Text.vue?vue&type=script&setup=true&lang=js"

import "./Text.vue?vue&type=style&index=0&id=f741c252&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f741c252"],['__file',"src/components/Paragraphs/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f741c252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f741c252', __exports__)) {
    api.reload('f741c252', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=f741c252&scoped=true", () => {
    api.rerender('f741c252', render)
  })

}


export default __exports__